// ======================================================================
// File Name       : userHistoryContent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getContentList(param) {
  return commonCallApi({
    path: 'content/GetList',
    data: param,
  });
}

export function getItemList(param) {
  return commonCallApi({
    path: 'item/GetList',
    data: param,
  });
}

export function getExecutionNumber(param) {
  return commonCallApi({
    path: 'learningOperation/GetHistoryList',
    data: param,
  });
}

export function getUserList(param) {
  return commonCallApi({
    path: 'user/GetList',
    data: param,
  });
}

export function getGroupList(param) {
  return commonCallApi({
    path: 'group/GetStructure',
    data: param,
  });
}

export function getGroupRelationList(param) {
  return commonCallApi({
    path: 'userGroupRelation/GetList',
    data: param,
  });
}

export function getEachItemStatusCount(param) {
  return commonCallApi({
    path: 'learningOperation/EachItemStatusCount',
    data: param,
  });
}

// #7386 START
export function getEachQuestionAnswerContentSummary(param) {
  return commonCallApi({
    path: 'learningOperation/EachQuestionAnswerContentSummary',
    data: param,
  });
}

export function getEachDrillEnforceStatusSummary(param) {
  return commonCallApi({
    path: 'learningOperation/EachDrillEnforceStatusSummary',
    data: param,
  });
}
// #7386 END
